<template>
  <div class="wrapper">
    <!-- 头图 -->
    <header>
      <img :src="bg_img" alt="背景图" class="header_img"/>
    </header>
    <img src="../../assets/image/invite/btn.png" alt="" class="btn_img" @click="to_miniprogram">
  </div>
</template>

<script>
  import _geturl from "@/utils/_geturl";
  import lib_activity from "@/libs/lib_activity";
  import lib_city from "@/libs/lib_city";
  import _wx from "@/common/_wx";
  import _time from "@/utils/_time";
  import _object from "@/utils/_object";
  import _monitor from "@/monitor/_monitor";
  import maanshan from   "../../assets/image/invite/maanshan.jpg"
  import deyang from   "../../assets/image/invite/deyang.jpg"
  import langfang from   "../../assets/image/invite/langfang.jpg"

  let action_form = {
    name: '', //姓名
    phone: '', //电话
    city: '', //城市
  }

  export default {
    name: "common",
    components: {
    },
    data() {
      return {
        title: '', // document的title
        activity_id: 0, //活动ID
        tids: "", //模板ID
        channel: '', //渠道
        channel_name: '', //渠道名
        tid: 0, // 有无车型库
        share_theme: '', //分享描述
        stime: 0, // 项目开始时间
        etime: 0, // 项目结束时间
        ui: {
          head: '', //头图
          tail: '', //详情图
          share: '', //分享图
          bg_color: '', //表单背景色
          font_color: '', //文本颜色
          btn_bg_color: '', //按钮背景色
          btn_font_color: '', //按钮文本颜色
          btn_text: '', //按钮文本值
          btm_btn_text: '', //底部按钮文本
          is_banner: 0, //是否有轮播图
          is_counter: 0, //是否有倒计时
          is_copyright: 1, //协议
          jmp_url: 0, //0-报名成功;1-帮朋友报名;2-置换二手车;3-邮寄门票
        },

        action_form: action_form,
        //城市联级选择
        citys: [], //城市数据
        cascaderProps: { //配置项
          expandTrigger: 'hover', //展开方式
          value: "id", //指定选项的值
          label: "name", //指定选项标签
          children: "children", //指定选项的子选项
          emitPath: false, //该节点数组
        },

        is_city: false, //表单城市项，默认无城市
        is_stop: false, //活动是否已结束


        // vant相关
        city_show: false,
        cascaderValue: '', //
        cityNames: {
          text: 'name',
          value: 'id',
          children: 'children',
        },
        bg_maanshan: maanshan,
        bg_deyang: deyang,
        bg_langfang: langfang,
        bg_img: '',

      }
    },
    created() {
      // 地址栏
      this.activity_id = _geturl("activity_id");
      this.tids = _geturl("tids");
      this.channel = _geturl("channel");
      this.channel_name = _geturl("channel_name");

      //获取项目信息
      lib_activity.info(this.activity_id, this.tids, this.init_info);

      //监测
      _monitor.init(this.channel, this.activity_id);

      if(this.activity_id == '1350') {
        this.bg_img = this.bg_maanshan
      } else if(this.activity_id == '1397') {
        this.bg_img = this.bg_deyang
      } else if(this.activity_id == '1452') {
        this.bg_img = this.bg_langfang
      }

    },

    methods: {
      //初始化项目信息
      init_info(data) {
        this.title = data.activity.theme;
        document.title = this.title;
        this.share_theme = data.activity.share_theme;
        this.etime = data.activity.etime;
        this.stime = data.activity.stime;
        this.tid = data.activity.tid;
        if(data.ui == null) {
          this.ui = {};
          return;
        }
        this.ui = data.ui;

        // 项目结束
        if (!data.activity.state || (_time._current() > data.activity.etime)) {
          this.is_stop = true;
          return;
        }
        // 判断是否有城市
        let city = []
        if (data.activity.city) {
          city = data.activity.city.split(',');
        }
        if (city.length == 1 && city[0] > 0) {
          //单城市项目
          this.is_city = false;
        } else {
          //多城市项目
          this.is_city = true;
          this.getCity(data.activity.city)
        }
        // 分享： ui存在再分享
        if (_object._length(this.ui) > 0) {
          this.share();
        }
      },

      // 分享
      share() {
        let that = this;
        lib_activity.share(function (data) {
          let options = {};
          options.title = that.title;
          options.desc = that.share_theme;
          options.link = window.location.href;
          options.image = that.ui.share;

          _wx.js_api(data, _wx.share, options);
        })
      },
      // 加载城市
      getCity(city) {
        let that = this;
        lib_city.list(city, function (data) {
          that.citys = data;
        })
      },

      to_miniprogram() {
        if(this.activity_id == '1397') {
          window.location.href = `https://wxaurl.cn/GgUfV6HF4ht`
        } else if(this.activity_id == '1350') {
          window.location.href = `https://wxaurl.cn/V5uf1qJE4Cm`
        } else if(this.activity_id == '1452') {
          window.location.href = `https://wxaurl.cn/akgs0M79DUi`
        }
      },

    },
  };
</script>
<style lang="less" scoped>
  .wrapper{
    position: relative;
  }
  .btn_img{
    position: absolute;
    width: 70%;
    height: auto;
    left: 15%;
    top: 58.5%;
    animation: 1s sxt infinite;
  }

  // 表单提交按钮  定义要跳动的动画
  @keyframes sxt {
    0% {
      transform: scale(0.9)
    }
    50% {
      transform: scale(1)
    }
    100% {
      transform: scale(0.9)
    }
  }
</style>



